/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type UpdateSubscriptionPathParams = NonNullable<operations['updateSubscription']['parameters']['path']>;

export type UpdateSubscriptionRequestBody = OperationRequestBodyContent<operations['updateSubscription']>;

export interface Input extends UpdateSubscriptionPathParams {
  apiVersion?: string;
  body: UpdateSubscriptionRequestBody;
}

export async function updateSubscription(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/integrations/{integrationKey}/{id}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
